import { useState } from 'react';
import type { CloudHandoffSource } from '@/lib/desktop-shell/cloud-handoff';
import type { SourceControlRepository } from '@/lib/source-control-connector';

const WORKSPACE_SOURCE: CloudHandoffSource = { type: 'workspace' };

/**
 * State for a cloud handoff: chosen repository, remote branches, source
 * selection, target agent, and progress/error notices. The composer branch
 * menu drives the source; the caller orchestrates source control lookup and transfer.
 */
export function useCloudHandoffDialog() {
  const [cloudHandoffRepository, setCloudHandoffRepository] =
    useState<SourceControlRepository | null>(null);
  const [cloudHandoffBranches, setCloudHandoffBranches] = useState<readonly string[]>([]);
  const [cloudHandoffSource, setCloudHandoffSource] =
    useState<CloudHandoffSource>(WORKSPACE_SOURCE);
  const [cloudHandoffAgentId, setCloudHandoffAgentId] = useState<string | null>(null);
  const [cloudHandoffWorking, setCloudHandoffWorking] = useState(false);
  const [cloudHandoffError, setCloudHandoffError] = useState<string | null>(null);
  const [cloudHandoffRemoteNotice, setCloudHandoffRemoteNotice] = useState<string | null>(null);

  /** Clear handoff fields back to the default workspace snapshot. */
  function resetCloudHandoffDialog(): void {
    setCloudHandoffError(null);
    setCloudHandoffRemoteNotice(null);
    setCloudHandoffRepository(null);
    setCloudHandoffBranches([]);
    setCloudHandoffSource(WORKSPACE_SOURCE);
    setCloudHandoffAgentId(null);
  }

  return {
    cloudHandoffRepository,
    setCloudHandoffRepository,
    cloudHandoffBranches,
    setCloudHandoffBranches,
    cloudHandoffSource,
    setCloudHandoffSource,
    cloudHandoffAgentId,
    setCloudHandoffAgentId,
    cloudHandoffWorking,
    setCloudHandoffWorking,
    cloudHandoffError,
    setCloudHandoffError,
    cloudHandoffRemoteNotice,
    setCloudHandoffRemoteNotice,
    resetCloudHandoffDialog,
  };
}
